'use strict';

define(['app', 'elementViewed', 'ePopup', 'siteObj'], function (app, elementViewed, ePopup, siteObj) {

  var papBanner = function papBanner() {
    var component = {};
    component.elementViewed = elementViewed;

    var _config = {
      selectors: {
        popupLink: '[data-js-element=popupLink]',
        popupBanner: '[data-js-element=papPopup]',
        papPopupContents: '[data-papPopup-contents]',
        readMoreTranslation: '[data-read-more-translation]'
      },
      attributes: {
        dataReadMoreTranslation: 'data-read-more-translation',
        ariaLabel: 'aria-label'
      },
      classes: {
        papBannerPopup: 'papBanner_popup'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      component.popupLink = component.element.querySelector(component.config.selectors.popupLink);
      component.popupBanner = component.element.querySelector(component.config.selectors.popupBanner);
      component.papPopupContents = component.element.querySelector(component.config.selectors.papPopupContents);

      var readMoreTranslation = component.element.querySelector(component.config.selectors.readMoreTranslation).getAttribute(component.config.attributes.dataReadMoreTranslation);
      var ariaLabel = component.popupLink.innerText + readMoreTranslation;
      component.popupLink.setAttribute(component.config.attributes.ariaLabel, ariaLabel);

      component.bind();

      if (siteObj.config.enableQubit === true) {
        siteObj.methods = siteObj.methods || {};
        siteObj.methods.qubitPapBanner = component.loadPapBanner;
      }

      return component;
    };

    var _bind = function _bind() {

      component.popupLink.addEventListener('click', component.papBannerClicked);
      component.elementViewed(component.element, component.papBannerViewed);
    };

    var _papBannerClicked = function _papBannerClicked(e) {
      if (e) {
        e.preventDefault();
      }
      component.loadPapBanner(component.papPopupContents);
    };

    var _loadPapBanner = function _loadPapBanner(papPopupContents) {
      component.ePopup = new ePopup(papPopupContents, component.config.classes.papBannerPopup, false, true);
      app.publish('tracking/record', 'Pap | papBanner', 'Clicked', 'papBanner component');
    };

    var _papBannerViewed = function _papBannerViewed() {
      app.publish('tracking/record', 'Pap | papBanner', 'Viewed', 'papBanner component');
    };
    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.papBannerClicked = _papBannerClicked;
    component.papBannerViewed = _papBannerViewed;
    component.loadPapBanner = _loadPapBanner;
    return component;
  };

  return papBanner;
});
//# sourceMappingURL=papBanner.js.map
